var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdviceNot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.83325C2 2.72869 2.89543 1.83325 4 1.83325H9.33333C11.9107 1.83325 14 3.92259 14 6.49992V13.1666C14 14.2712 13.1046 15.1666 12 15.1666H4C2.89543 15.1666 2 14.2712 2 13.1666V3.83325ZM8.66667 3.16659H4C3.63181 3.16659 3.33333 3.46507 3.33333 3.83325V13.1666C3.33333 13.5348 3.63181 13.8333 4 13.8333H12C12.3682 13.8333 12.6667 13.5348 12.6667 13.1666V6.49992H8.66667V3.16659ZM12.3893 5.16656C11.9609 4.18593 11.0742 3.45129 10 3.23324V5.16656H12.3893ZM4.66667 7.16658H7.33333V5.83325H4.66667V7.16658ZM4.66667 9.83325H11.3333V8.49992H4.66667V9.83325ZM11.3333 12.4999H4.66667V11.1666H11.3333V12.4999Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviceNot);
export default __webpack_public_path__ + "static/media/advice-not.e617b626201a4ef7f7c7e4819a372f0f.svg";
export { ForwardRef as ReactComponent };